import { campaignConstants } from '../constants';

export function campaigns(state = {}, action) {
  switch (action.type) {
    case campaignConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case campaignConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case campaignConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddCampaign(state = {}, action) {
  switch (action.type) {
    case campaignConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case campaignConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case campaignConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetCampaign(state = {}, action) {
  switch (action.type) {
    case campaignConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case campaignConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case campaignConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateCampaign(state = {}, action) {
  switch (action.type) {
    case campaignConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case campaignConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case campaignConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}